import Brands from "@src/views/panel/ops/brands";
import Dashboard from "@src/views/panel/ops/dashboard";
import BrandDetails from "@src/views/panel/ops/brands/details";
import OnboardBrand from "@src/views/panel/ops/brands/new";
import Settings from "@src/views/panel/ops/settings";
import UserGuide from "@src/views/panel/ops/guide";
import Disbursements from "@src/views/panel/ops/disbursements";
import DebitNotesList from "@src/views/panel/ops/debit-notes";
import Publishers from "@src/views/panel/ops/publishers";
import PublisherDetails from "@src/views/panel/ops/publishers/details";
import Contracts from "@src/views/panel/ops/contracts";
import { PAYMENT_MODEL } from "@constants/panel/common";

const OpsRoutes = [
    {
        path   : "dashboard",
        element: <Dashboard />,
        meta   : {
            resource: "dashboard",
            title   : "Dashboard",
            action  : "read"
        }
    },
    {
        path   : "brands",
        element: <Brands />,
        meta   : {
            resource: "brands",
            title   : "Brands",
            action  : "read"
        }
    },
    {
        path   : "brands/new",
        element: <OnboardBrand />,
        meta   : {
            resource: "brands",
            title   : "Onboard Brand",
            action  : "read"
        }
    },
    {
        path   : "brands/details/:id",
        element: <BrandDetails />,
        meta   : {
            resource: "brands",
            title   : "Brand Details",
            action  : "read"
        }
    },
    {
        path   : "settings",
        element: <Settings />,
        meta   : {
            resource: "settings",
            title   : "Settings",
            action  : "read"
        }
    },
    {
        path   : "guide",
        element: <UserGuide />,
        meta   : {
            resource: "guide",
            title   : "User Guide",
            action  : "read"
        }
    },
    // Disbursements and debit notes only exist under managed payouts — `meta.paymentModel`
    // bounces the URL while the Ops topbar toggle sits on self payout, which is also
    // what hides both from the nav (see navigation/index.js).
    {
        path   : "disbursements",
        element: <Disbursements />,
        meta   : {
            resource    : "disbursements",
            title       : "Disbursements",
            action      : "read",
            paymentModel: PAYMENT_MODEL.MANAGED_PAYOUT
        }
    },
    {
        path   : "debit-notes",
        element: <DebitNotesList />,
        meta   : {
            resource    : "debit-notes",
            title       : "Debit Notes",
            action      : "read",
            paymentModel: PAYMENT_MODEL.MANAGED_PAYOUT
        }
    },
    {
        path   : "publishers",
        element: <Publishers />,
        meta   : {
            resource: "publishers",
            title   : "Publishers",
            action  : "read"
        }
    },
    {
        path   : "publishers/details/:id",
        element: <PublisherDetails />,
        meta   : {
            resource: "publishers",
            title   : "Publisher Details",
            action  : "read"
        }
    },
    {
        path   : "contracts",
        element: <Contracts />,
        meta   : {
            resource: "contracts",
            title   : "Contracts",
            action  : "read"
        }
    }
];

export default OpsRoutes;
